import Component from '@bythepixel/component-loader';
import { breakpoints } from '@Front/constants';
import Splide from '@splidejs/splide';
import { splideOptions } from './config';

export default class SectionFeatures extends Component {
  static selector = '[data-comp-section-features]';

  constructor(containerEl) {
    super(containerEl);
    this.slider = new Splide('.splide', splideOptions);

    this.mount();
  }

  attachListeners() {
    const mediaQuery = `(max-width: ${breakpoints['break-2']}px)`;

    window
      .matchMedia(mediaQuery)
      .addEventListener('change', (e) => (e.matches ? this.slider.mount() : this.slider.destroy()));
  }

  isMobile() {
    return window.matchMedia(`(max-width: ${breakpoints['break-2']}px)`)
      .matches;
  }

  mount() {
    this.attachListeners();

    if (this.isMobile()) {
      this.slider.mount();
    }
  }
}
